import { createStore, Store } from 'redux';
import { verificationServiceReducer } from '../../lib/VerificationService/verificationServiceReducer';
import { ReduxState, ReduxAction } from '../types/types';

type VerificationStore = Store<ReduxState, ReduxAction>;
let store: VerificationStore;

export const getStore = (): VerificationStore => {
    if (!store) {
        store = createStore<ReduxState, ReduxAction, void, void>(
            verificationServiceReducer,
            // @ts-ignore
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
        );
    }

    return store;
};
